import { useEffect } from 'react';
import { sessionContent } from '@/features/auth/content/session';
import { setSessionExpiredHandler } from '@/lib/api/client';
import { toast } from '@/lib/toast';
import { isGoogleReturn, loadSession, setSessionUser } from './session';
import { useAuthStore } from './store';

/**
 * Restores the session on app start: calls `GET /auth/me` once on mount (ignoring 401) and wires the
 * API client so that a definitively rejected refresh token signs the user out everywhere — and tells
 * a person who *was* signed in that their session ended ("Your session ended — please sign in again"),
 * A stale "session exists" hint on a fresh page load ends quietly: nobody
 * was signed in, so there is nothing to announce. Renders nothing; mount it once inside the providers.
 */
export function AuthBootstrap() {
  useEffect(() => {
    setSessionExpiredHandler(() => {
      const wasSignedIn = useAuthStore.getState().user !== null;
      setSessionUser(null);
      if (wasSignedIn) {
        const copy = sessionContent;
        toast({ title: copy.endedTitle, description: copy.endedDescription });
      }
    });
    const controller = new AbortController();
    // `/login?via=google`: the API has just signed this browser in, which it has no hint of yet
    void loadSession(controller.signal, { force: isGoogleReturn() });
    return () => {
      controller.abort();
      setSessionExpiredHandler(null);
    };
  }, []);

  return null;
}
